<template>
  <modal
    name="openTabFinishOrdering"
    modal-style="compact"
    :display-header-title="false"
    required
  >
    <open-tab-finish-ordering />
  </modal>
</template>


<script>
  import OpenTabFinishOrdering from './open-tab-finish-ordering/index.vue';


  export default {
    name: 'OpenTabFinishOrderingModal',

    components: {
      OpenTabFinishOrdering
    }
  };
</script>
